import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/* ─── Icons ───────────────────────────────────────────────────────────────── */
const DashboardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <rect x="3" y="3" width="7" height="7" rx="2" />
    <rect x="14" y="3" width="7" height="4" rx="2" />
    <rect x="14" y="10" width="7" height="11" rx="2" />
    <rect x="3" y="13" width="7" height="8" rx="2" />
  </svg>
);
const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const ServiceIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M14.7 6.3a1 1 0 0 0-1.4 0l-7 7a1 1 0 0 0 0 1.4l3 3a1 1 0 0 0 1.4 0l7-7a1 1 0 0 0 0-1.4l-3-3z" />
    <path d="M17 3l4 4" />
  </svg>
);
const PromoIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M21 5H9l-4 4 4 4h12l2-2V7a2 2 0 0 0-2-2Z" />
    <circle cx="15" cy="9" r="1.5" />
  </svg>
);
const TicketIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M3 8a2 2 0 0 1 2-2h14v4a2 2 0 1 0 0 4v4H5a2 2 0 0 1-2-2z" />
    <path d="M13 6v12" />
  </svg>
);
const BackupIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5-5 5 5M12 5v12" />
  </svg>
);
const SignOutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </svg>
);
const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="w-5 h-5">
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);
const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="w-5 h-5">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <path d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const LiveSupportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <circle cx="9" cy="10" r="1" fill="currentColor" />
    <circle cx="12" cy="10" r="1" fill="currentColor" />
    <circle cx="15" cy="10" r="1" fill="currentColor" />
  </svg>
);

/* ─── Menu config ─────────────────────────────────────────────────────────── */
const MENU_ITEMS = [
  { label: 'Dashboard', sub: null,         path: '/admin/dashboard',    icon: <DashboardIcon /> },
  { label: 'Live Support',     sub: null,      path: '/admin/live-support', icon: <LiveSupportIcon /> },
  { label: 'Users',     sub: 'Management', path: '/admin/users',        icon: <UsersIcon /> },
  { label: 'Services',  sub: 'Management', path: '/admin/services',     icon: <ServiceIcon /> },
  { label: 'Promo',     sub: null,         path: '/admin/promo',        icon: <PromoIcon /> },
  { label: 'Tickets',   sub: 'Management', path: '/admin/tickets',      icon: <TicketIcon /> },
  { label: 'Backup',    sub: null,         path: '/admin/backup',       icon: <BackupIcon /> },
];

const SIDEBAR_GRADIENT = 'linear-gradient(160deg, #9e6a5a 0%, #7a5049 40%, #5c3832 100%)';

/* ─── Shared nav content ──────────────────────────────────────────────────── */
const SidebarContent = ({ expanded, onNavigate, activePath }) => (
  <div className="flex h-full flex-col overflow-y-auto overflow-x-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">

    {/* Brand */}
    <div className={`flex shrink-0 items-center mb-8 ${expanded ? 'gap-3 px-1' : 'justify-center'}`}>
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/15 border border-white/25 text-white">
        <ShieldIcon />
      </div>
      {expanded && (
        <div className="overflow-hidden">
          <p className="m-0 text-[10px] font-bold tracking-[0.22em] text-white/50 uppercase">Hygea</p>
          <p className="m-0 text-sm font-bold text-white whitespace-nowrap">System Admin</p>
        </div>
      )}
    </div>

    {/* Section label */}
    {expanded && (
      <p className="mb-2 px-3 text-[9px] font-extrabold tracking-[0.25em] text-white/30 uppercase">
        Navigation
      </p>
    )}

    {/* Nav items */}
    <nav className="flex flex-col gap-0.5 flex-1">
      {MENU_ITEMS.map((item) => {
        const active = activePath === item.path;
        return (
          <div key={item.path} className="relative group">

            {/* Active accent bar — a real <span> instead of ::before */}
            <span
              aria-hidden="true"
              className={[
                'absolute left-0 top-1/2 -translate-y-1/2 w-[3px] rounded-r-sm bg-white transition-all duration-200',
                active ? 'h-[60%] opacity-100' : 'h-0 opacity-0',
              ].join(' ')}
            />

            <button
              onClick={() => onNavigate(item.path)}
              className={[
                'relative flex w-full items-center rounded-xl px-3 py-2.5 transition-all duration-200 overflow-hidden',
                expanded ? 'justify-start gap-3' : 'justify-center',
                active
                  ? 'bg-white/20 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.15),0_4px_12px_rgba(0,0,0,0.15)]'
                  : 'text-white/65 hover:bg-white/10 hover:text-white',
              ].join(' ')}
            >
              {active && <span className="absolute inset-0 rounded-xl bg-white/5 pointer-events-none" />}

              <span className={`flex-shrink-0 transition-colors ${active ? 'text-white' : 'text-white/60 group-hover:text-white'}`}>
                {item.icon}
              </span>

              {expanded && (
                <span className="flex-1 text-left leading-tight">
                  <span className={`block text-[12px] tracking-wide ${active ? 'text-white font-bold' : 'font-semibold'}`}>
                    {item.label}
                  </span>
                  {item.sub && (
                    <span className={`block text-[10px] tracking-widest uppercase ${active ? 'text-white/70' : 'text-white/35'}`}>
                      {item.sub}
                    </span>
                  )}
                </span>
              )}

              {/* Active dot when collapsed */}
              {active && !expanded && (
                <span className="absolute bottom-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white/80" />
              )}
            </button>

            {/* Tooltip — replaces .nav-tooltip + ::before arrow, collapsed desktop only */}
            {!expanded && (
              <span className="pointer-events-none absolute left-full top-1/2 z-[100] ml-3 -translate-y-1/2 whitespace-nowrap rounded-lg bg-[#1a1a2e] px-3 py-1.5 text-[11px] font-bold tracking-[0.06em] text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100">
                {item.label}{item.sub ? ` ${item.sub}` : ''}
                {/* Arrow pointing left */}
                <span
                  aria-hidden="true"
                  className="absolute right-full top-1/2 -translate-y-1/2 border-[5px] border-transparent border-r-[#1a1a2e]"
                />
              </span>
            )}
          </div>
        );
      })}
    </nav>

    {/* Divider */}
    <div className="my-3 mx-2 h-px bg-white/10" />

    {/* Sign Out */}
    <button
      onClick={() => onNavigate('/')}
      className={[
        'group flex w-full shrink-0 items-center rounded-xl border border-white/15 bg-white/[0.08] px-3 py-2.5 text-white/60 transition-all duration-200 hover:bg-red-500/20 hover:border-red-400/30 hover:text-red-200',
        expanded ? 'gap-3' : 'justify-center',
      ].join(' ')}
    >
      <span className="flex-shrink-0 transition-colors group-hover:text-red-300">
        <SignOutIcon />
      </span>
      {expanded && (
        <span className="text-[12px] font-bold tracking-widest uppercase">Sign Out</span>
      )}
    </button>
  </div>
);

/* ─── Main component ──────────────────────────────────────────────────────── */
const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [desktopExpanded, setDesktopExpanded] = useState(false);
  const [mobileOpen, setMobileOpen]           = useState(false);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavigate = (path) => { navigate(path); setMobileOpen(false); };

  return (
    <>
      {/* ══════════════════════════════════════
          MOBILE  (visible below sm / < 640 px)
      ══════════════════════════════════════ */}

      {/* Fixed top bar */}
      <div
        className="fixed inset-x-0 top-0 z-40 flex h-14 items-center justify-between border-b border-white/10 px-4 sm:hidden"
        style={{ background: 'linear-gradient(90deg, #8B5E52 0%, #7a5049 100%)' }}
      >
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15 border border-white/20 text-white">
            <ShieldIcon />
          </div>
          <div>
            <p className="m-0 text-[9px] font-extrabold tracking-[0.2em] text-white/50 uppercase">Hygea</p>
            <p className="m-0 text-xs font-bold text-white">System Admin</p>
          </div>
        </div>

        <button
          onClick={() => setMobileOpen((p) => !p)}
          className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/15 border border-white/20 text-white transition-all hover:bg-white/25 active:scale-95"
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>

      {/* Spacer — keeps page content below the fixed top bar */}
      <div className="h-14 shrink-0 sm:hidden" />

      {/* Backdrop — fades in/out via opacity transition */}
      <div
        onClick={() => setMobileOpen(false)}
        className={[
          'fixed inset-0 z-40 bg-black/50 backdrop-blur-sm sm:hidden transition-opacity duration-300',
          mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
        ].join(' ')}
      />

      {/* Drawer — slides in/out via translateX */}
      <div
        className={[
          'fixed left-0 top-0 bottom-0 z-50 w-72 sm:hidden',
          'transition-transform duration-300 ease-[cubic-bezier(.34,1.2,.64,1)]',
          mobileOpen ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
        style={{ background: SIDEBAR_GRADIENT }}
      >
        <div className="h-full p-4">
          <SidebarContent
            expanded={true}
            onNavigate={handleNavigate}
            activePath={location.pathname}
          />
        </div>
      </div>

      {/* ══════════════════════════════════════
          DESKTOP  (visible sm+ / ≥ 640 px)
      ══════════════════════════════════════ */}
      <aside
        onMouseEnter={() => setDesktopExpanded(true)}
        onMouseLeave={() => setDesktopExpanded(false)}
        className={[
          'hidden sm:flex flex-col sticky top-0 h-screen z-30',
          'transition-[width] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]',
          desktopExpanded ? 'w-60' : 'w-[72px]',
        ].join(' ')}
        style={{ background: SIDEBAR_GRADIENT }}
      >
        <div className="relative m-2 flex flex-1 flex-col overflow-visible rounded-2xl border border-white/10 bg-white/5 p-3 shadow-[0_20px_40px_rgba(0,0,0,0.25)] backdrop-blur-sm">
          {/* Top shimmer line */}
          <div className="pointer-events-none absolute inset-x-0 top-0 h-px rounded-t-2xl bg-gradient-to-r from-transparent via-white/25 to-transparent" />
          <SidebarContent
            expanded={desktopExpanded}
            onNavigate={handleNavigate}
            activePath={location.pathname}
          />
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;